import type { SxProps, Theme } from '@mui/material/styles';

const stateColor = (
	isError: boolean,
	isDirty: boolean,
	defaultColor: string | undefined
) =>
	isError
		? 'var(--mui-palette-error-main)'
		: isDirty
			? 'var(--mui-palette-success-light)'
			: defaultColor;

const stackingOrder = {
	position: 'relative',
	zIndex: 0,
	'&:hover': { zIndex: 1 },
	'&:focus-within': { zIndex: 2 }
} as const;

export const phoneNumberInputStyles = {
	row: {
		display: 'flex',
		width: '100%'
	},

	countrySelectRoot: (
		callingCodeLength: number,
		hasFlag: boolean
	): SxProps<Theme> => {
		const flagSpace = hasFlag ? 0 : 30;

		return {
			width: 92 + callingCodeLength * 8 - flagSpace,
			flexShrink: 0,
			...stackingOrder,
			'@media (max-width: 400px)': {
				width: 62 + callingCodeLength * 8 - flagSpace
			}
		};
	},

	countrySelect: {
		'& .MuiOutlinedInput-root': {
			borderTopRightRadius: 0,
			borderBottomRightRadius: 0,
			paddingRight: '4px !important'
		},
		'& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
			borderColor: 'var(--mui-palette-primary-main)'
		},
		'& .MuiAutocomplete-endAdornment': {
			marginLeft: '6px'
		}
	},

	selectedFlagAdornment: {
		marginRight: '4px',
		'@media (max-width: 400px)': {
			display: 'none'
		}
	},

	selectedFlag: {
		width: 20,
		height: 15,
		marginLeft: '6px',
		flexShrink: 0,
		objectFit: 'cover',
		borderRadius: '2px'
	},

	option: {
		display: 'flex',
		alignItems: 'center',
		gap: 1,
		width: '100%'
	},

	optionFlag: {
		width: 20,
		height: 15,
		flexShrink: 0,
		objectFit: 'cover',
		borderRadius: '2px'
	},

	optionName: {
		flex: 1,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap'
	},

	optionCode: {
		color: 'text.secondary',
		flexShrink: 0
	},

	popper: {
		width: 'fit-content',
		minWidth: 280
	},

	phoneInput: (isError: boolean, isDirty: boolean): SxProps<Theme> => ({
		flex: 1,
		minWidth: 0,
		marginLeft: '-1px',
		...stackingOrder,

		'& .MuiOutlinedInput-input': {
			color: stateColor(isError, isDirty, 'var(--mui-palette-text-primary)'),
			WebkitTextFillColor: 'currentColor'
		},
		'& .MuiOutlinedInput-root': {
			borderTopLeftRadius: 0,
			borderBottomLeftRadius: 0
		},
		'& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
			borderColor: stateColor(isError, isDirty, 'var(--mui-palette-divider)')
		},
		'& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
			borderColor: stateColor(isError, isDirty, undefined)
		},
		'& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
			borderColor: 'var(--mui-palette-primary-main)'
		}
	})
};
